const TRANSLATION_NAME_SPACE = 'apollo_search_lut'

export const TRANSLATION_KEYS = {
  dialogHeader: `${TRANSLATION_NAME_SPACE}__apollo_dialog__header`,
  explanationMessage: `${TRANSLATION_NAME_SPACE}__apollo_dialog__explanation-message`,

  tableColumns: {
    name: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__column_name`,
    partnerId: 'onb_partner_id',
    partnerType: 'partnerbasicinfo-distributor-key',
    hierarchy: 'partner_hierarchy-table-columns-hierarchy',
    country: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__column_country`,
    state: 'onb_state',
    city: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__column_city`,
    taxId: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__column_tax_id`,
    postalCode: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__column_postal_code`,
    addressLine1: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__column_address_line1`,
    addressLine2: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__column_address_line2`,
    addressLine3: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__column_address_line3`,
    website: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__column_website`,

    subTable: {
      field: `${TRANSLATION_NAME_SPACE}__apollo_dialog__compare-table_col_field`,
      compared: `${TRANSLATION_NAME_SPACE}__apollo_dialog__compare-table_col_compared`,
      original: `${TRANSLATION_NAME_SPACE}__apollo_dialog__compare-table_col_original`,
      status: `${TRANSLATION_NAME_SPACE}__apollo_dialog__compare-table_col_status`,
    },
  },

  applyApolloMatch: `${TRANSLATION_NAME_SPACE}__apollo_dialog__table__apply-apollo-match`,

  cancelButton: `${TRANSLATION_NAME_SPACE}__apollo-dialog__cancel-button`,
  submitButton: `${TRANSLATION_NAME_SPACE}__apollo-dialog__submit-user-form-button`,
}
